export class FundReportPageCategory {
  public static formsInstructions = 'Forms & Instructions';
  public static fundDocuments = 'Fund Documents';
  public static fundLiterature = 'Fund Literature';
  public static disclosureDocument = 'Disclosure Document';
  public static updates = 'Updates';
  public static informationRatio = 'Information Ratio';


  // SIF page categories
  public static sifReports = 'SIF Reports';
  public static sifFormsInstructions = 'SIF Forms & Instructions';
  public static sifFundDocuments = 'SIF Fund Documents';
  public static sifFundLiterature = 'SIF Fund Literature';
  public static sifDisclosureDocument = 'SIF Disclosure Document';
  public static sifUpdates = 'SIF Updates';
  public static sifInformationRatio = 'SIF Information Ratio';

  public static formsInstructionsValue = 'FORMS-AND-INSRTUCTIONS';
  public static fundDocumentsValue = 'FUND-DOCUMENT';
  public static fundLiteratureValue = 'FUND-LITERATURE';
  public static disclosureDocumentValue = 'DISCLOSURE-DOCUMENT';
  public static updatesValue = 'UPDATES';
  public static reportsValue = 'REPORTS';
  public static informationRatioValue = 'INFORMATION-RATIO';

  // SIF page type values
  public static sifReportsValue = 'SIF-REPORTS';
  public static sifFormsInstructionsValue = 'SIF-FORMS-AND-INSTRUCTIONS';
  public static sifFundDocumentsValue = 'SIF-FUND-DOCUMENT';
  public static sifFundLiteratureValue = 'SIF-FUND-LITERATURE';
  public static sifDisclosureDocumentValue = 'SIF-DISCLOSURE-DOCUMENT';
  public static sifUpdatesValue = 'SIF-UPDATES';
  public static sifInformationRatioValue = 'SIF-INFORMATION-RATIO';

  public static report = 'report';
  public static download = 'download';
  public static sebifiling = 'sebifiling';
  public static sifReport = 'sifReport';
  public static sifDownload = 'sifDownload';
}
